import { dom } from './dom.js';

export function enableExplanationScrollLayout() {
    if (document.documentElement.classList.contains('game-scrollable')) return;

    const isCompact = window.matchMedia('(max-width: 639px)').matches;
    if (isCompact) {
        const { height } = dom.radarContainer.getBoundingClientRect();
        dom.radarContainer.style.minHeight = `${height}px`;
    }

    dom.radarContainer.style.flex = 'none';
    document.documentElement.classList.add('game-scrollable');
    dom.gameShell.classList.add('game-shell--scrollable');
}

export function disableExplanationScrollLayout() {
    dom.radarContainer.style.minHeight = '';
    dom.radarContainer.style.flex = '';
    document.documentElement.classList.remove('game-scrollable');
    dom.gameShell.classList.remove('game-shell--scrollable');
}
